import { TranslocoPipe, provideTranslocoScope } from '@jsverse/transloco';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

// Esito dell'invio: senza autorizzazioni da chiedere la proposta è già trasmessa
@Component({
  providers: [provideTranslocoScope('orders')],
  selector: 'ord-proposal-sent-dialog',
  imports: [TranslocoPipe, MatButtonModule, MatDialogModule],
  template: `
    <mat-dialog-content class="sent-content">
      <div class="sent-icon">
        <i class="fa-solid fa-check"></i>
      </div>
      <span class="title-medium">{{ 'orders.ui.propostaInviata' | transloco }}</span>
      <span class="body-small">
        {{ data.inAuthorization ? (('orders.ui.laPropostaEStataInviataPerLAutorizzazione' | transloco)) : (('orders.ui.laPropostaEStataTrasmessa' | transloco)) }}
      </span>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button matButton="filled" type="button" class="sent-home" mat-dialog-close>{{ 'orders.ui.tornaAllaHome' | transloco }}</button>
    </mat-dialog-actions>
  `,
  styles: `
    .sent-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: var(--mat-sys-spacing-8);
      text-align: center;
    }

    .sent-icon {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 56px;
      height: 56px;
      border-radius: 100%;
      background-color: var(--mat-sys-primary-container);
    }

    .sent-home {
      width: 100%;
    }
  `,
})
export class ProposalSentDialog {
  readonly data = inject<{ inAuthorization: boolean }>(MAT_DIALOG_DATA);
}
